import type { BooleanFunction } from "./boolean-functions";
import type { FormkitReference } from "./references";

/**
 * Unary, Binary, and raw boolean data
 */
export type StandardBoolean = UnaryBoolean | BinaryBoolean | boolean;

/**
 * Either a standard boolean OR a function
 */
export type FormkitBoolean = StandardBoolean | FunctionBoolean;

export const isFormkitBoolean = (value: any): value is FormkitBoolean => {
  return [BooleanType.Binary, BooleanType.Unary, BooleanType.Function].includes(
    value?.type,
  );
};

export enum BooleanType {
  Unary = "unary",
  Binary = "binary",
  Function = "function",
}

export type UnaryBoolean = {
  type: BooleanType.Unary;
  operand: BooleanOperand | UnaryBoolean | BinaryBoolean;
  operator?: UnaryBooleanOperator;
};

export type BinaryBoolean = {
  type: BooleanType.Binary;
  leftOperand: BooleanOperand;
  operator: BinaryBooleanOperator;
  rightOperand: BooleanOperand;
};

export type FunctionBoolean = {
  type: BooleanType.Function;
  variables: Record<string, unknown> | null;
  function: keyof BooleanFunction;
};

export type BooleanOperand =
  | FormkitBoolean
  | FormkitReference
  | string
  | number
  | boolean;

export enum UnaryBooleanOperator {
  Not = "not",
}

export enum BinaryBooleanOperator {
  Equals = "equals",
  NotEquals = "notEquals",
  GreaterThan = "greaterThan",
  LessThan = "lessThan",
  GreaterThanOrEqual = "greaterThanOrEqual",
  LessThanOrEqual = "lessThanOrEqual",
  And = "and",
  Or = "or",
  Xor = "xor",
}
